/* hcRequest libreria para realizar peticiones(requests)*/
import hcRequest from "@/helper/hc-request";
/* urlcontext donde se encuntra la base de la api*/
import urlcontext from '@/services/conf/axios.urlcontext';
/*httphelper para obtener la function donde se configura los headers*/
import httphelper from '@/services/conf/httphelper'

export default {
    
    getConfiguration(){

        let apiPasswordConf = new hcRequest()
        /*Se configura el interceptor */
        /*Base de la api*/
        apiPasswordConf.base = urlcontext.APP_AUTH_BASE
        /* Headers*/
        apiPasswordConf.headers = httphelper.getCoreHeaders()
        /*Autorizacion */
        apiPasswordConf.authorization = httphelper.getToken()
        
        return apiPasswordConf
    }

}    

